import FTPlayerOptions from "./ft-player-options";
import Media from "./media";
import { isAutoplaySupported, isVideo } from "./utils";


export default class FTStreamingPlayer {

  videoEl!: HTMLVideoElement
  autoplay: boolean = true
  media!: any
  sourceEl!: HTMLSourceElement
  options!: FTPlayerOptions
  processedAutoplay: boolean = false;
  canAutoplay: boolean = false;
  canAutoplayMuted: boolean = false;

  private static _instance: FTStreamingPlayer

  public static getInstance(videoElement: HTMLVideoElement): FTStreamingPlayer {
    if (!FTStreamingPlayer._instance) {
      FTStreamingPlayer._instance = new FTStreamingPlayer();
      FTStreamingPlayer._instance.videoEl = videoElement
      FTStreamingPlayer._instance.autoplay = videoElement.autoplay;
      FTStreamingPlayer._instance.options = new FTPlayerOptions()
      FTStreamingPlayer._instance.init();
    }

    return FTStreamingPlayer._instance;
  }

  init() {
    this._prepareMedia();
  }

  set src(media) {
    if (this.media instanceof Media) {
      //this._addSource(media);
      this.media.mediaFiles = [];
      this.options = media.options;
      this.media.loaded = false;
      this.media.src = media;
    }
  }

  get src() {
    return this.media.src;
  }

  set currentTime(value) {
    this.media.currentTime = value;
  }

  get currentTime() {
    return this.media ? this.media.currentTime : this.videoEl.currentTime;
  }

  get duration() {
    const duration = this.media ? this.media.duration : this.videoEl.duration;
    if (duration === Infinity && this.videoEl.seekable && this.videoEl.seekable.length) {
      return this.videoEl.seekable.end(0);
    }
    return duration;
  }

  canPlayType(mimeType) {
    if (this.media) {
      return this.media.canPlayType(mimeType);
    }
    return false;
  }

  load = () => {
    if (this.media && !this.media.loaded) {
      this.media.load();
      this.media.loaded = true;
    }
  }

  play = () => {
    if (this.media && !this.media.loaded) {
      this.media.load();
    }
    return this.media.play();
  }

  pause() {
    this.media.pause();
  }

  destroy() {
    const el = (this.videoEl);
    this.media.pause();
    this.media.destroy();
    this._removeSource();
    el.removeAttribute('src');
  }

  getElement = () => {
    return this.videoEl;
  }

  addEventListener(type: any, listener: any, options?: any) {
    if (this.videoEl) {
      this.videoEl.addEventListener(type, listener, options);
      this.videoEl.addEventListener('playerError', listener, options);
    }
  }

  removeEventListener(type: any, listener: any, options?: any) {
    if (this.videoEl) {
      this.videoEl.removeEventListener(type, listener, options);
    }
  }

  _addSource = (media) => {
    this._removeSource();
    if (this.videoEl) {
      this.sourceEl = document.createElement('source');
      this.sourceEl.setAttribute('src', media.src);
      this.sourceEl.setAttribute('type', media.type);
      this.videoEl.appendChild(this.sourceEl);
    }
  }

  _removeSource = () => {
    this.sourceEl = null;
    if (this.videoEl) {
      this.videoEl.innerHTML = '';
    }
  }

  _prepareMedia() {
    try {
      if (this.autoplay && isVideo(this.videoEl)) {
        this.videoEl.addEventListener('canplay', this._autoplay, false);
      }
      this.media = new Media(this.videoEl, this.autoplay);
    } catch (e) {
      //console.error(e);
    }
  }

  _autoplay = () => {
    this.videoEl.removeEventListener('canplay', this._autoplay, false);
    if (!this.media) return;
    if (!this.processedAutoplay) {
      this.processedAutoplay = true;


      isAutoplaySupported(this.videoEl, autoplay => {
        this.canAutoplay = autoplay;
      }, muted => {
        this.canAutoplayMuted = muted;
      }, () => {
        if (this.canAutoplayMuted) {
          this.videoEl.muted = true;
          this.videoEl.volume = 0;

          const e = addEvent('volumechange');
          this.videoEl.dispatchEvent(e);
        } else {
          this.videoEl.muted = false;
          this.videoEl.volume = 1;
        }
        if (this.canAutoplay || this.canAutoplayMuted) {
          return this.play();
        }
      });
    } else {
      if (this.canAutoplay || this.canAutoplayMuted) {
        //return this.play();
      }
    }
  }
}
